import React from 'react';

import SidebarAccordianDiv from './SidebarAccordianDiv/SidebarAccordianDiv';
import SidebarAccordianLazyMotion from './SidebarAccordianLazyMotion/SidebarAccordianLazyMotion';
import SidebarAccordionChevron from './SidebarAccordionChevron/SidebarAccordionChevron';
import { SidebarAccordionProps } from './types';

const SidebarAccordion: React.FC<React.PropsWithChildren<SidebarAccordionProps>> = ({
  isExpanded,
  children,
}) => {
  return (
    <SidebarAccordianLazyMotion isExpanded={isExpanded}>
      {<SidebarAccordianDiv>{children}</SidebarAccordianDiv>}
    </SidebarAccordianLazyMotion>
  );
};

export {
  SidebarAccordionChevron as Chevron,
  SidebarAccordianDiv as Div,
  SidebarAccordianLazyMotion as LazyMotion,
  SidebarAccordion as Main,
};
